import React, {useEffect, useState} from 'react';
import {requestCandidateGroups, requestDeleteGroup} from "@app/services/CandidateGroupService";
import {toast} from "react-toastify";
import {CANDIDATE_GROUP_ORDER_BY, DEFAULT_PAGE_SIZE, ODER_BY_TYPE, ORDER_BY} from "@app/constants/Common";
import TableListPaging from "@app/components/TableListPaging";
import UpdateJobPipelineModal from "@pages/jobpipeline/edit/UpdateJobPipelineModal";
import JobPipelineTableList from "@pages/jobpipeline/list/JobPipelineTableList";
import SettingHideColumnsModal from "@pages/jobpipeline/list/SettingHideColumnsModal";
import {requestGetJobPipeLineList} from "@app/services/JobPipelineService";
import AdvanceSearchJobPipelineModal from "@pages/jobpipeline/list/advancesearch/AdvanceSearchJobPipelineModal";
import {FollowUpUserCddDiscussionTabIds, RunJobParentTabIds} from "@pages/job/runjob/RunJobParentTabContent";
import {
    CddStatus,
    JobPipelineTableColumns,
    ProcessJobInternalProcess,
    TodoWithPersons
} from "@pages/jobpipeline/common/Constant";

const InitSearch = {
    search_conditions: {
    },
    // mỗi phần tử gồm key column, loại sort
    sort_columns: {
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    },
}
const JobPipeLineList = (props) => {
    const [pipeLineList, setPipeLineList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [selectRow, setSelectRow] = useState(null);
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showBtnAddPipelineOnRefereeInput, setShowBtnAddPipelineOnRefereeInput] = useState(false);
    const [showHideColumnSettingModal, setShowHideColumnSettingModal] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(1);
    const [hideColumns, setHideColumns] = useState({});
    const [searchInput, setSearchInput] = useState(InitSearch);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    let pipelineId = "";
    if (props.location && props.location.search) {
        pipelineId = new URLSearchParams(props.location.search).get("id")
    }

    const {runJobMode, jobId, pTab, sTab, runJob, showFullSearch} = props

    const searchPipeLines = async (conditions) => {
        console.log("Search conditions:" + JSON.stringify(conditions))
        if (conditions) {
            searchInput.search_conditions = {...conditions}
            searchInput.search_conditions.run_job_mode = runJobMode
            searchInput.search_conditions.run_job_id = runJob ? runJob.id : ""
            searchInput.search_conditions.parent_tab = pTab ? pTab.id : ""
            searchInput.search_conditions.sub_tab = sTab ? sTab.id : ""
            if (runJobMode) {
                let cons = searchInput.search_conditions
                if (pTab && pTab.id === RunJobParentTabIds.FOLLOW_UP_USER_CDD_DISCUSSION) {
                    if (sTab?.id === FollowUpUserCddDiscussionTabIds.NOT_CATEGORY) {
                        cons.cdd_status = CddStatus.UV_EMAIL_REPLY
                        cons.todo_with_person = TodoWithPersons.DONE_PERIOD_BEFORE_SENDING
                    } else if (sTab?.id === FollowUpUserCddDiscussionTabIds.TO_SEND) {
                        cons.internal_process = ProcessJobInternalProcess.WaitingSend
                        cons.todo_with_person = TodoWithPersons.DONE_PERIOD_BEFORE_SENDING
                    }
                }


                searchInput.search_conditions.job_id = jobId
            }
            setSearchInput({...searchInput})
        }

        setShowSearchModal(false)
        setIsLoading(true)

        const res = await requestGetJobPipeLineList(searchInput);

        setIsLoading(false)
        const resContent = res.content
        setTotalCount(resContent.totalCount)
        const items = resContent.job_pipe_lines.map((item, index) => {
            item.no = (resContent.page - 1) * DEFAULT_PAGE_SIZE + index + 1
            return item
        });
        setPipeLineList(items);
        setNumberPages(Math.ceil(resContent.totalCount / DEFAULT_PAGE_SIZE))
    }

    const onSort = async (columnKey) => {
        let sortColumns = searchInput.sort_columns
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        searchInput.sort_columns = sortColumns

        await searchPipeLines()
    }

    useEffect(() => {
        if (pipelineId) {
            searchInput.search_conditions.id = pipelineId
        }
        searchInput.search_conditions.job_id = jobId
        searchInput.search_conditions.run_job_mode = runJobMode

        setSearchInput({...searchInput})

        onSort('created_date_time')
    }, [jobId, runJobMode, pTab, sTab]);

    // const onChangeOrderBy = async (event) => {
    //     searchInput.search_conditions.order_by = event.target.value
    //     setSearchInput({...searchInput})
    //     await searchPipeLines(searchInput)
    // }

    const onCloseUpdatePipeLine = async (reload) => {
        setShowUpdateModal(false)

        // Xử lý ẩn hiện button add pipeline trên màn hình input referee.
        setShowBtnAddPipelineOnRefereeInput(!reload)

        if (reload) {
            await searchPipeLines()
        }
    }

    const nextPage = async () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchInput.search_conditions.page = currPage
            await searchPipeLines()
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const backPage = async () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchInput.search_conditions.page = currPage
            await searchPipeLines()
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };

    const onSaveHideColumnsSettings = (settings) => {
        setShowHideColumnSettingModal(false)
        setHideColumns({...settings})
    }

    const onShowEditItem = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectRow({...item})
        setShowUpdateModal(true)
    }

    const onAddItem = () => {
        setSelectRow({})
        setShowUpdateModal(true)
    }

    return (
        <div className="container-fluid">
            <div className="card card-primary">
                <div className="card-header">
                    <h3 className='card-title text-bold'>{'Kho Job pipeline'}</h3>
                    <div className='card-tools'>
                        <a href='#'
                           className=''
                           onClick={() => {
                               setShowSearchModal(true)
                           }}>
                            <i className='fas fa-filter mr-2'/>
                        </a>
                    </div>
                </div>
                <div className='card-body p-2'>
                    <div className="card card-default">
                        <div className="card-header">
                            <h3 className="card-title text-bold mt-2">Job Pipeline ({totalCount})</h3>
                            {totalCount > 0 &&
                            <h3 className='card-title text-bold ml-3 mt-2'>Page: {currentPage}/{numberPages}</h3>
                            }
                            <div className="btn-group ml-3">
                                <button type="button" className="btn btn-default">Actions</button>
                                <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                        data-toggle="dropdown">
                                    <span className="sr-only">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu" role="menu">
                                    <button type={"button"}
                                            onClick={onAddItem}
                                            className={'dropdown-item'}>Tạo mới Job Pipeline
                                    </button>
                                    <button type={"button"}
                                            onClick={() => {
                                                setShowHideColumnSettingModal(true)
                                            }}
                                            className={'dropdown-item'}>Settings
                                    </button>
                                    {userLoginInfo.is_superuser &&
                                    <button type={"button"}
                                            onClick={() => {
                                            }}
                                            className={'dropdown-item'}>Xoá Job Pipeline
                                    </button>
                                    }
                                    {/*<button type={"button"}*/}
                                    {/*        onClick={() => {}}*/}
                                    {/*        className={'dropdown-item'}>Chỉnh sửa Job Pipeline*/}
                                    {/*</button>*/}
                                    {/*<button type={"button"}*/}
                                    {/*        onClick={() => {}}*/}
                                    {/*        className={'dropdown-item'}>Duplicate Job Pipeline*/}
                                    {/*</button>*/}
                                </div>
                            </div>
                            <div className={'card-tools'}>
                                {/*<button type={"button"}*/}
                                {/*        className='btn btn-success'*/}
                                {/*        onClick={() => {*/}

                                {/*        }}>*/}
                                {/*    Add Job Pipeline*/}
                                {/*</button>*/}
                                {/*{totalCount > 0 &&*/}
                                {/*<select className='ml-3'*/}
                                {/*        style={{*/}
                                {/*            padding: '0.375rem 0.75rem',*/}
                                {/*            backgroundColor: '#fff',*/}
                                {/*            border: '1px solid #ced4da',*/}
                                {/*            borderRadius: '0.25rem',*/}
                                {/*            boxShadow: 'inset 0 0 0 transparent',*/}
                                {/*            transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'*/}
                                {/*        }}*/}
                                {/*        name={'order_by'}*/}
                                {/*        value={orderBy}*/}
                                {/*        onChange={event => onChangeOrderBy(event)}>*/}
                                {/*    <option value='1'>Cập nhật mới hơn trước</option>*/}
                                {/*    <option value='2'>Cập nhật cũ hơn trước</option>*/}
                                {/*    <option value='3'>Sắp xếp theo tên A-Z</option>*/}
                                {/*    <option value='4'>Sắp xếp theo tên Z-A</option>*/}
                                {/*</select>*/}
                                {/*}*/}
                                {numberPages > 1 &&
                                <TableListPaging onBack={backPage} onNext={nextPage}/>
                                }
                            </div>
                            {isLoading &&
                            <div className={'col-sm-12 text-center'}
                                 style={{
                                     position: 'absolute',
                                     top: '50%',
                                     left: '50%',
                                     transform: 'translate(-50%, -50%)'
                                 }}>
                                <div className='spinner-grow text-primary' role='status'>
                                    <span className='sr-only'>Loading...</span>
                                </div>
                            </div>
                            }
                        </div>
                        <div className="card-body p-0">
                            <JobPipelineTableList pipeLines={pipeLineList}
                                                  hideColumns={hideColumns}
                                                  showBtnAddPipelineOnRefereeInput={showBtnAddPipelineOnRefereeInput}
                                                  onSort={onSort}
                                                  sortColumn={searchInput.sort_columns}
                                                  onEditItem={(selectItem, fromReferee) => onShowEditItem(selectItem, fromReferee)}
                                                  onClose={(reload) => onCloseUpdatePipeLine(reload)}/>
                        </div>
                    </div>
                </div>
            </div>
            <UpdateJobPipelineModal isShow={showUpdateModal}
                                    pipeLineInfo={selectRow}
                                    onClose={(reload) => onCloseUpdatePipeLine(reload)}
            />
            <SettingHideColumnsModal isShow={showHideColumnSettingModal}
                                     columns={JobPipelineTableColumns}
                                     onSave={(settings) => {
                                         onSaveHideColumnsSettings(settings)
                                     }}
                                     onClose={() => setShowHideColumnSettingModal(false)}
            />

            <AdvanceSearchJobPipelineModal
                isShow={showSearchModal}
                onClose={() => setShowSearchModal(false)}
                showFullSearch={!!showFullSearch}
                searchInput={searchInput.search_conditions}
                onSearch={(conditions) => searchPipeLines(conditions)}/>

        </div>
    );
};

export default JobPipeLineList;
